import { Box, styled } from '@mui/material';
import { Link } from '~/components/link';

export const FolderContainer = styled(Box)(() => ({ display: 'flex' }));

export const FolderChildren = styled(Box)(() => ({ alignItems: 'center', display: 'flex' }));

export const FolderLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(1, 0),
  textDecoration: 'none',
}));

export const FolderNotLink = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(1, 0),
}));

export const FolderIconContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  padding: theme.spacing(1),
  width: '50px',
}));

export const FolderMetaContainer = styled(Box)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
}));
